import { H1, H2, P, PBold } from '@components/Typography';

import styled from 'styled-components';

export const EventParticipationSectionContainer = styled.div<{
  backgroundColor?: string;
}>`
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.color.white};
  margin-top: 6rem;
`;

export const SectionTitle = styled(H1)<{
  color?: string;
}>`
  color: ${({ theme, color }) => color ?? theme.color.white};
  font-size: ${({ theme }) => theme.fontSize.size50};
  text-transform: uppercase;
  text-align: center;
  padding-bottom: 1rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding-left: 2rem;
    padding-right: 2rem;
    text-align: left;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
    line-height: 5.4rem;
  }
`;

export const UnderlineContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    justify-content: start;
    padding: 0 2rem;
  }
`;

export const Underline = styled.div<{
  color?: string;
}>`
  background-color: ${({ color, theme }) => color || theme.color.white};
  width: 163px;
  height: 0.4rem;
`;

export const Title = styled(H2)<{
  color?: string;
}>`
  color: ${({ theme, color }) => color ?? theme.color.white};
  font-size: ${({ theme }) => theme.fontSize.size35};
  line-height: ${({ theme }) => theme.lineHeight.height150};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
    line-height: 5.4rem;
  }
`;

export const ImageWrapper = styled.div`
  height: 59rem;
  border-bottom-right-radius: 6rem;
  border-top-right-radius: 6rem;
  overflow: hidden;
  position: relative;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    height: 92vh;
    border-bottom-right-radius: 0;
  }
`;

export const EventParticipationSectionRoot = styled.div`
  display: grid;
  grid-template-columns: 49% 51%;
  padding-top: 6rem;
  padding-bottom: 6rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    display: flex;
    flex-direction: column;
  }
`;

export const AlignLeft = styled.div`
  padding-bottom: 1.3rem;
  margin-right: auto;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 0;
  }
`;

export const EventStatisticsItemsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  width: 100%;
`;

export const StatTitle = styled(PBold)<{ color?: string }>`
  color: ${({ color, theme }) => color || theme.color.white};
  font-size: ${({ theme }) => theme.fontSize.size30};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  line-height: ${({ theme }) => theme.lineHeight.height125};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size28};
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size26};
  }
`;

export const DescriptionText = styled(P)<{
  color?: string;
}>`
  color: ${({ theme, color }) => color ?? theme.color.white};
  font-size: ${({ theme }) => theme.fontSize.size18};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size16};
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }
`;

export const TextWrapper = styled.div`
  padding: 1rem 6rem 0 0;
  margin-left: 9rem;
  width: min(100%, 60rem);
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    margin-left: 8rem;
    width: min(100%, 55rem);
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    margin: auto;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 0;
    width: min(100%, 50rem);
  }
`;
